import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isConnectedAccount } from 'owa-accounts-store';
import getCurrentEventUserIdentity from '../selectors/getCurrentEventUserIdentity';
import { isFeatureEnabled } from 'owa-feature-flags';

export default (formId: string) => {
    const userIdentity = getCurrentEventUserIdentity(formId);

    return (
        isFeatureEnabled('cal-mf-timeSuggestions') &&
        !isConsumer(userIdentity) &&
        !isConnectedAccount(
            userIdentity
        ) /* disable suggestions for consumer scenario and any type of connected account*/
    );
};
